var moduleMap = {
	"./AuthContext": () => {
		return Promise.all([__webpack_require__.e(878), __webpack_require__.e(53)]).then(() => (() => ((__webpack_require__(9053)))));
	},
	"./ThemeContext": () => {
		return Promise.all([__webpack_require__.e(878), __webpack_require__.e(522), __webpack_require__.e(844)]).then(() => (() => ((__webpack_require__(6844)))));
	},
	"./ConfigContext": () => {
		return Promise.all([__webpack_require__.e(878), __webpack_require__.e(522), __webpack_require__.e(549)]).then(() => (() => ((__webpack_require__(549)))));
	},
	"./EventBus": () => {
		return Promise.all([__webpack_require__.e(522), __webpack_require__.e(734)]).then(() => (() => ((__webpack_require__(8734)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});